<template>
  <div class="swiper-card">
    <div class="game-bg"></div>
    <div class="corner-radius-blur newsle"></div>
    <div class="confetti"></div>

    <div class="game-content">
      <h1>Nice work!</h1>
      <p>You got {{ getResults }}/5 answers correct!</p>
      <div class="results-group">
        <div class="result" v-for="result in results" :key="result.slug" :class="{'correct' : result.correct}">
          <svg v-if="result.correct" width="449" height="416" viewBox="0 0 449 416" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M438.05 4.50173C448.85 12.2017 451.25 27.2017 443.55 38.0017L179.55 406.002C175.45 411.702 169.05 415.402 162.05 415.902C155.05 416.402 148.05 414.002 143.05 409.002L7.05 273.002C-2.35 263.602 -2.35 248.402 7.05 239.102C16.45 229.802 31.65 229.702 40.95 239.102L157.05 355.002L404.55 10.0017C412.25 -0.798272 427.25 -3.19827 438.05 4.50173Z" />
          </svg>

          <svg v-else width="384" height="384" viewBox="0 0 384 384" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.05 40.95C-2.35 31.55 -2.35 16.35 7.05 7.05C16.45 -2.25 31.65 -2.35 40.95 7.05L191.95 158.05L342.95 7.05C352.35 -2.35 367.55 -2.35 376.85 7.05C386.15 16.45 386.25 31.65 376.85 40.95L225.85 191.95L376.85 342.95C386.25 352.35 386.25 367.55 376.85 376.85C367.45 386.15 352.25 386.25 342.95 376.85L191.95 225.85L40.95 376.85C31.55 386.25 16.35 386.25 7.05 376.85C-2.25 367.45 -2.35 352.25 7.05 342.95L158.05 191.95L7.05 40.95Z" />
          </svg>
        </div>
      </div>
      <p>Come back tomorrow and try again with brand new stories happening around the world.</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    computed: {
      getResults() {
        return this.results.filter(a => a.correct).length;
      },

      results() {
        return [
          {
            slug: 'one',
            correct: true,
          },
          {
            slug: 'two',
            correct: false,
          },
          {
            slug: 'three',
            correct: true,
          },
          {
            slug: 'four',
            correct: true,
          },
          {
            slug: 'five',
            correct: false,
          },
        ]
      }
    },
    
    methods: {
      startPlaying() {
        this.EventBus.$emit('swiper:next')
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .game-bg {
    background: linear-gradient(180deg, #03132F 0%, rgba(144, 0, 212, 0.5) 99.99%);
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 0;
  }

  .game-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    padding-top: 6rem;
    z-index: 10;
  }

  h1 {
    font-size: 60px !important;
    line-height: 100%;
    font-weight: normal;
    text-wrap: balance;
  }

  p {
    font-size: 20px;
    line-height: 150%;
    text-wrap: balance;
  }

  .results-group {
    display: flex;
    align-items: center;
    gap: 1rem;

    .result {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      border-radius: 500px;
      background: $red-tone-3;

      &.correct {
        background: $green-tone-3;
      }

      svg {
        width: 0.75rem;
        height: 0.75rem;

        path {
          fill: $neutral-600;
        }
      }
    }
  }

  .confetti {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10rem;
    min-width: 500px;
    z-index: 0;
    background-image: url('@assets/images/onboarding-confetti.png');
    background-size: cover;
    background-position: bottom;

    .desktop & {
      height: 15rem;
    }
  }
</style>